function CompletedTabView () {}

/**
 * View for a completed game tab which displays user picked numbers
 */
Object.assign( CompletedTabView.prototype, {
	mount: function ( rootNode ) {
		this.rootNode = rootNode;
	},
	unmount: function () {
		this.rootNode = null;
	},
	/**
	 * populates html based on user picked numbers
	 * @param {array} numbers - user picked numbers for a game
	 */
	processNumbersHTML: function ( numbers ) {
		let numbersHTML = ``;

		numbers.forEach( function ( number ) {
			numbersHTML +=
				`<li class='card-tab__completed__num'><span class='card-tab__completed__num__val'>` +
				number +
				`</span></li>`;
		});
		this.rootNode.innerHTML = numbersHTML;
	},
	displayHTML: function ( html ) {
		this.rootNode.innerHTML = html;
	}
});

export default CompletedTabView;
